import PropTypes from 'prop-types';
export const productsPropType = PropTypes.shape({
  productName: PropTypes.string.isRequired,
  productKey: PropTypes.string.isRequired
});
export const alternativeOfferingPropType = PropTypes.shape({
  daysRemaining: PropTypes.number,
  offeringName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
});
export const offeringPropType = PropTypes.shape({
  daysRemaining: PropTypes.number,
  offeringName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  sheetCount: PropTypes.number,
  startDate: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(productsPropType.isRequired).isRequired,
  alternativeSubscription: alternativeOfferingPropType,
  status: PropTypes.string.isRequired
});
//# sourceMappingURL=types.js.map